import React, {useState, useEffect} from 'react';
import { MapPin, Car } from 'lucide-react';
import { Link } from 'react-router-dom';
import ReservationModal from './ReservationModal';
import { api } from '../../api/api';
import Swal from 'sweetalert2';
import Loader from '../Loader';

function ReservationCard({ vehicle, booking }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);


  const modalOpen = () => {
    setIsModalOpen(true);
  };

  const modalClose = () => {
    setIsModalOpen(false);
  };

   // const ownerResponse = await api.post("/users/getUserById", { 
      //           userId: vehicleData.userId 
      //         });
              
      //         setVehicleOwner(ownerResponse.data.user);
      //         console.log(ownerResponse.data.user);
 

  function handleAccept() {
    setLoading(true);
    api.post("/bookings/acceptBooking", { bookingId: booking._id })
      .then((response) => {
        setLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Booking Accepted',
          text: 'The booking has been accepted successfully. If you need to reject simply click on the Reject button.'
        }).then(() => {
          window.location.reload(); // Reload after user clicks "OK"
        });
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Something went wrong while accepting the booking.'
        });
        console.error("Error accepting booking:", error);
      });
  }
  

  function handleReject() {
    setLoading(true);
    api.post("/bookings/rejectBooking", { bookingId: booking._id })
      .then((response) => {
        setLoading(false);
        Swal.fire({
          icon: 'success',
          title: 'Booking Rejected',
          text: 'The booking has been rejected successfully. If you need to accept simply click on the Accept button.'
        }).then(() => {
          window.location.reload(); // Reload after user clicks "OK"
        });
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong while rejecting the booking.'
        });
        console.error("Error rejecting booking:", error);
      });
  }
  


  return (
    <>
     {loading && <div className="absolute inset-0 bg-white z-10"> <Loader/> </div>}
     {isModalOpen && (
            <ReservationModal
              isOpen={isModalOpen}
              onClose={modalClose}
              booking={booking}
            />
          )}
    <div className="w-full max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden md:flex">
      {/* Vehicle Image */}
      <div className="md:w-1/3 md:flex-shrink-0 flex items-center">
        <div className="aspect-[16/9] w-full relative">
          <img 
            src={vehicle?.imageURLs[0]} 
            alt={vehicle?.name || 'Vehicle'} 
            className="w-full h-full object-cover"
          />
          {/* Status badge overlaid on image */}
          <div className="absolute top-3 right-3">
            {booking?.isAccepted === "accepted" ? (
              <span className="bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-lg shadow-sm">
                Accepted
              </span>
            ) : booking?.isAccepted === "rejected" ? (
              <span className="bg-red-100 text-red-800 text-sm font-medium px-3 py-1 rounded-lg shadow-sm">
                Rejected
              </span>
            ) : (
              <span className="bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1 rounded-lg shadow-sm">
                Pending
              </span>
            )}
          </div>
        </div>
      </div>
      
      {/* Vehicle Details */}
      <div className="p-4 md:w-1/3 sm:flex flex-col justify-center items-start">
        <div className="font-bold text-xl mb-3">{vehicle?.name || 'Vehicle Name'}</div>
        
        <div className="space-y-2">
          <div className="flex items-center text-gray-700">
            <Car className="w-4 h-4 mr-2" />
            <span className="text-sm">{vehicle?.type || 'Vehicle Type'}</span>
          </div>
          
          <div className="flex items-center text-gray-700">
            <MapPin className="w-4 h-4 mr-2" />
            <span className="text-sm">{vehicle?.city || 'Location'}</span>
          </div>
          
    
        </div>
      </div>
      
      {/* Action Buttons */}
      <div className="p-4 md:w-1/3  sm:flex items-center justify-center">
        <div className="grid grid-cols-2 gap-3">
          <button className="bg-red-100 hover:bg-red-200 text-red-700 font-medium py-2 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center" onClick={handleReject}>
            Reject
          </button>
          <button className="bg-green-100 hover:bg-green-200 text-green-700 font-medium py-2 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center" onClick={handleAccept}>
            Accept
          </button>
          <Link className="bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium py-2 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center" to={`/view/${vehicle._id}`} >
          <button>
            Vehicle
          </button>
          </Link>
          <button className="bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium py-2 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center" onClick={modalOpen}>
            Booking
          </button>
        </div>
        
 
      </div>
    </div>
    </>
  );
}

export default ReservationCard;